import * as React from "react";
import { Theme } from "@radix-ui/themes";
import { useAppearance } from "./appearance.ts";

interface Props {
  children?: React.ReactNode;
}

// Radix's components in the app's scheme. Their surfaces are re-coloured to the palette in
// index.css, so dialogs and menus sit on the same paper as the cards.
export const StashItTheme: React.FC<Props> = ({ children }) => {
  const { scheme } = useAppearance();
  return (
    <Theme
      appearance={scheme}
      accentColor="brown"
      grayColor="sand"
      panelBackground="solid"
      radius="large"
      hasBackground={false}
    >
      {children}
    </Theme>
  );
};
